const en = {
  premiumInterview: {
    badge: "Premium AI Experience",
    heroTitle1: "Real-Time",
    heroTitle2: "AI Avatar Interview",
    windowTitle: "HireThink Premium Live AI Interview",
    heroSubtitle:
      "Deliver a real interview experience with your candidates using the most advanced AI technology. Transform your hiring process with live avatars, natural conversation, and instant analysis.",
    imageAlt: "Premium AI Avatar Interview Experience",
    floatBadge1Title: "24/7 Interviews",
    floatBadge1Desc: "Always ready",
    floatBadge2Title: "Unlimited Candidates",
    floatBadge2Desc: "At the same time",
    floatBadge3Title: "Natural Dialogue",
    floatBadge3Desc: "Realistic experience",
    featuresTitle: "Premium Interview Features",
    featuresSubtitle: "An interview experience powered by the most advanced AI technology",
    feature1Title: "Multiple Avatar Options",
    feature1Desc:
      "Choose the avatar that best fits your company from a wide variety of looks and personalities. Each avatar provides a professional and trustworthy interview experience.",
    feature2Title: "Company-Specific Fine-Tuning",
    feature2Desc:
      "Quickly adjust pronunciation for words you don’t like or industry terms—tailored to your company. Make the avatar speak exactly the way you want.",
    feature3Title: "Advanced Anomaly Detection",
    feature3Desc:
      "Detects unusual behavior by analyzing eye movements, facial expressions, and tone of voice. Protects interview integrity.",
    feature4Title: "Multi-Language Support",
    feature4Desc:
      "Natural speech support in 30+ languages. Understand different accents and access the global talent pool with accurate pronunciation.",
    feature5Title: "Secure & KVKK Compliant",
    feature5Desc:
      "All interview recordings are stored encrypted on secure servers. Fully compliant with KVKK and GDPR standards.",
    feature6Title: "Detailed Analytics Reports",
    feature6Desc:
      "Make data-driven decisions with competency-based scoring, sentiment analysis, and comparative evaluations.",
    benefitsTitle: "Why Premium Interview?",
    benefitsSubtitle: "Take your hiring process to the next level",
    benefit1: "Offer candidates a real interview experience",
    benefit2: "Save time and cost",
    benefit3: "Fair and standardized evaluation for every candidate",
    benefit4: "Uninterrupted 24/7 interview availability",
    benefit5: "Make the right decisions with detailed competency analytics",
    benefit6: "Strengthen your employer brand image",
    ctaTitle: "Try Premium AI Interview",
    ctaSubtitle: "Request a demo now and transform your hiring process",
    ctaButton: "Request a Demo",
    aboutTitle: "What Is a Premium Live AI Avatar Interview?",
    aboutText: "A premium live AI avatar interview is a real-time interview format where an AI avatar connects with the candidate in a natural conversation flow. The AI analyzes the candidate's responses, tone, and eye movements instantly, flags anomalies, and generates a competency report at the end. Supporting 30+ languages, this AI interview format saves recruiting teams significant time in high-volume or multi-location hiring.",
    faqTitle: "Premium Live AI Avatar Interview — Frequently Asked Questions",
    faq1Q: "How does premium live AI avatar interview work?",
    faq1A: "The AI avatar connects with the candidate in real time and asks pre-defined competency questions in a natural conversation flow. All responses are analyzed instantly and a competency report is generated at the end of the session.",
    faq2Q: "How long does a live interview session take?",
    faq2A: "Session length depends on your question set and time settings. A typical premium live AI avatar interview takes between 15 and 40 minutes.",
    faq3Q: "What is anomaly detection and how does it work?",
    faq3A: "Anomaly detection automatically flags unusual behavior during the interview — such as multiple faces detected, eye movement patterns, audio changes, and tab or window switching. These findings are presented to the recruiter in an anomaly report.",
    faq4Q: "How many candidates can be evaluated simultaneously?",
    faq4A: "HireThink's infrastructure supports multiple candidates in separate interview sessions at the same time, subject to your plan limits.",
    faq5Q: "Which languages are supported?",
    faq5A: "The premium live AI avatar interview supports 30+ languages. The avatar voice is delivered with natural speech quality."
  },

  standardInterview: {
    heroTitle1: "Standard Video",
    heroTitle2: "AI Interview",
    windowTitle: "HireThink Standard Video AI Interview",
    heroSubtitle:
      "Let AI run asynchronous video interviews; AI generates interviewer videos, delivers instant scores, and produces shareable reports.",
    imageAlt: "Standard video AI interview experience",
    floatBadge1Title: "24/7 Interviews",
    floatBadge1Desc: "Always ready",
    floatBadge2Title: "Unlimited Candidates",
    floatBadge2Desc: "At the same time",
    floatBadge3Title: "Advanced Customization",
    floatBadge3Desc: "1000+ ready avatars",
    featuresTitle: "Standard Video Features",
    featuresSubtitle: "Reliable asynchronous video interviews with transparent scoring",
    feature1Title: "1000+ Avatar Options",
    feature1Desc:
      "Choose the best fit for your company from many different avatars—or create your own avatar.",
    feature2Title: "Company-Specific Fine-Tuning",
    feature2Desc:
      "Quickly adjust pronunciation for words you don’t like or industry terms; make the avatar speak exactly the way you want.",
    feature3Title: "Advanced Anomaly Detection",
    feature3Desc:
      "Analyzes candidate movements and browser activity, reports unusual situations, and keeps them recorded in the report.",
    feature4Title: "Multi-Language Support",
    feature4Desc: "Natural speech in 30+ languages; accent-friendly recognition and accurate pronunciation.",
    feature5Title: "Secure & KVKK Compliant",
    feature5Desc: "Recordings are encrypted on secure servers; KVKK/GDPR compliant.",
    feature6Title: "Detailed Analytics Reports",
    feature6Desc:
      "Make data-driven decisions with competency-based scores, Q&A scores, anomaly detection, and comparative evaluations.",
    ctaTitle: "Try Standard AI Interview",
    ctaSubtitle: "Request a demo now and transform your hiring process",
    ctaButton: "Request a Demo",
    aboutTitle: "What Is a Standard Video AI Interview?",
    aboutText: "A standard video AI interview is an asynchronous interview format where candidates record their answers on video whenever it suits them. Once the candidate finishes, AI automatically evaluates the responses and produces a competency-based score report within minutes. Because no scheduling is required, standard video interviews save significant time and cost in high-volume hiring.",
    faqTitle: "Standard Video AI Interview — Frequently Asked Questions",
    faq1Q: "How does asynchronous video interview work?",
    faq1A: "Candidates receive an interview link by email and record their video answers at their own convenience. The recordings are then automatically evaluated by AI, which generates a competency report with scores.",
    faq2Q: "How long does a video interview take?",
    faq2A: "Duration depends on the number of questions and time limits you configure. A typical session takes between 10 and 30 minutes.",
    faq3Q: "What devices can candidates use to join?",
    faq3A: "Candidates can join from any device with a camera and microphone — computer, tablet, or smartphone — directly via browser. No app download is required.",
    faq4Q: "When is the AI evaluation ready?",
    faq4A: "AI evaluation is typically ready within minutes of the candidate completing the interview. Competency scores, ranked results, and anomaly findings are instantly available to the recruiter.",
    faq5Q: "What happens if a candidate abandons the interview?",
    faq5A: "If the interview link is still valid, the candidate can re-enter via the same link and continue from where they left off. This event is flagged in the anomaly report."
  },

  voiceInterview: {
    heroTitle1: "Voice",
    heroTitle2: "AI Interview",
    windowTitle: "HireThink Voice AI Interview",
    heroSubtitle: "A phone-like AI interview with no scheduling—natural dialogue and instant scoring.",
    imageAlt: "Voice AI interview experience",
    floatBadge1Title: "24/7 Interviews",
    floatBadge1Desc: "Always ready",
    floatBadge2Title: "Unlimited Candidates",
    floatBadge2Desc: "At the same time",
    floatBadge3Title: "Accessible",
    floatBadge3Desc: "Easy phone usage",
    featuresTitle: "Voice Interview Features",
    featuresSubtitle: "The most accessible interview model—analyzed within minutes",
    feature1Title: "Access from Anywhere",
    feature1Desc:
      "Join from any device, anywhere; a perfect solution even for weak internet connections and low hardware requirements.",
    feature2Title: "Company-Specific Fine-Tuning",
    feature2Desc:
      "Quickly adjust pronunciation for words you don’t like or industry terms—tailored to your company. Make the avatar speak exactly the way you want.",
    feature3Title: "Advanced Anomaly Detection",
    feature3Desc:
      "Detects unusual behavior by analyzing eye movements, facial expressions, and tone of voice. Protects interview integrity.",
    feature4Title: "Multi-Language Support",
    feature4Desc:
      "Natural speech support in 30+ languages. Understand different accents and access the global talent pool with accurate pronunciation.",
    feature5Title: "Secure & KVKK Compliant",
    feature5Desc:
      "All interview recordings are stored encrypted on secure servers. Fully compliant with KVKK and GDPR standards.",
    feature6Title: "Detailed Analytics Reports",
    feature6Desc:
      "Make data-driven decisions with competency-based scoring, sentiment analysis, and comparative evaluations.",
    ctaTitle: "Try Voice AI Interview",
    ctaSubtitle: "Request a demo now and transform your hiring process",
    ctaButton: "Request a Demo",
    aboutTitle: "What Is a Voice AI Interview?",
    aboutText: "A voice AI interview is a fully audio-based interview format that requires no camera. Candidates can join from any microphone-enabled device, including a smartphone, while AI analyzes vocal tone, fluency, and content to generate an instant competency report. This makes voice AI interviews one of the most accessible interview formats available.",
    faqTitle: "Voice AI Interview — Frequently Asked Questions",
    faq1Q: "How is voice interview different from video interview?",
    faq1A: "Voice interviews require no camera — the entire interview is conducted over audio only. Candidates can join via phone or any microphone-enabled device. AI analyzes tone, fluency, and content rather than video.",
    faq2Q: "Can voice interviews be conducted over the phone?",
    faq2A: "Yes. Voice interviews can be completed via any device's microphone through a browser, including smartphones. This makes it one of the most accessible interview formats available.",
    faq3Q: "How does AI evaluate voice responses?",
    faq3A: "AI analyzes vocal tone, speech fluency, content quality, and competency alignment. All factors are scored and a structured competency report is generated instantly.",
    faq4Q: "How long does a voice interview take?",
    faq4A: "Duration depends on the number of questions and time limits configured. Most voice interviews are completed within 10 to 25 minutes."
  },

  whatsappInterview: {
    heroTitle1: "WhatsApp",
    heroTitle2: "AI Interview",
    windowTitle: "HireThink WhatsApp Interview",
    heroSubtitle: "Conduct AI-powered written interviews through the platform candidates use every day. Track job-search status and send process updates — all via WhatsApp.",
    imageAlt: "WhatsApp AI interview experience",
    floatBadge1Title: "Instant Interaction",
    floatBadge1Desc: "Real-time AI",
    floatBadge2Title: "Zero Friction",
    floatBadge2Desc: "No app download",
    floatBadge3Title: "Process Updates",
    floatBadge3Desc: "Automated notifications",
    featuresTitle: "WhatsApp Interview Features",
    featuresSubtitle: "Real-time AI-powered interview experience through the platform candidates use every day",
    feature1Title: "Familiar Platform, Zero Learning Curve",
    feature1Desc: "No app to download, no portal to learn. Candidates join via WhatsApp — the app they already use daily. Interview participation rates exceed 90%.",
    feature2Title: "Real-Time AI Interaction",
    feature2Desc: "AI evaluates each response instantly, manages the conversation flow, and dynamically advances the question sequence based on the candidate's answers.",
    feature3Title: "Job-Search Status Tracking",
    feature3Desc: "Query whether a candidate is still actively seeking a new role — directly via WhatsApp. Instantly bring suitable candidates into the hiring funnel.",
    feature4Title: "Automated Process Notifications",
    feature4Desc: "Interview invitations, reminders, result notifications, and next-step updates are automatically sent to candidates as WhatsApp messages.",
    feature5Title: "Secure & GDPR Compliant",
    feature5Desc: "All conversation data is stored encrypted on secure servers. Fully compliant with KVKK and GDPR standards.",
    feature6Title: "Detailed Competency Report",
    feature6Desc: "Written responses are scored by AI using rubric-based evaluation. Competency scores, strengths, and development areas are delivered in a structured report.",
    ctaTitle: "Try WhatsApp AI Interview",
    ctaSubtitle: "Request a demo now and transform your hiring process",
    ctaButton: "Request a Demo",
    faqTitle: "WhatsApp AI Interview — Frequently Asked Questions",
    faq1Q: "How does WhatsApp interview work?",
    faq1A: "The candidate receives an interview invitation via WhatsApp. The AI assistant conducts the interview through a messaging conversation, evaluating responses in real time. A competency report is generated at the end.",
    faq2Q: "Does the candidate need a WhatsApp Business account?",
    faq2A: "No. A standard WhatsApp account is sufficient. No additional app download or account creation is required.",
    faq3Q: "How does job-search status tracking work via WhatsApp?",
    faq3A: "HireThink AI messages the candidate via WhatsApp to ask whether they are still actively seeking a new role. Suitable candidates are immediately brought into the funnel; passive candidates are automatically added to a follow-up list.",
    faq4Q: "How are process notifications delivered?",
    faq4A: "Interview invitations, reminders, result notifications, and next-step updates are automatically sent to the candidate as WhatsApp messages — no manual intervention required from the recruiter."
  },
  phoneInterview: {
    heroTitle1: "Phone",
    heroTitle2: "AI Interview",
    windowTitle: "HireThink Phone Interview",
    heroSubtitle: "HireThink AI calls the candidate from the 0850 line. Fully automated, real-time interactive voice interview — nothing required except a phone.",
    imageAlt: "Phone AI interview experience",
    floatBadge1Title: "Auto Dial",
    floatBadge1Desc: "AI calls the candidate",
    floatBadge2Title: "Instant Scoring",
    floatBadge2Desc: "Real-time analysis",
    floatBadge3Title: "Any Phone",
    floatBadge3Desc: "No app needed",
    featuresTitle: "Phone Interview Features",
    featuresSubtitle: "Fully automated, interactive voice interview via the HireThink AI 0850 line",
    feature1Title: "AI Auto-Dial",
    feature1Desc: "HireThink AI calls the candidate from 0850 307 80 61. The moment the candidate picks up, a personalized interview begins — no extra login or link required.",
    feature2Title: "Re-Ask a Question",
    feature2Desc: "If the candidate didn't hear or understand a question, they can request it verbally. AI will repeat the question clearly and calmly.",
    feature3Title: "Reschedule to a Convenient Time",
    feature3Desc: "If the candidate isn't available at the moment, they can state a preferred day and time. AI creates the appointment and automatically calls back at the scheduled time.",
    feature4Title: "Off-Topic Answer Detection",
    feature4Desc: "If a response is unrelated to the question, AI detects this and politely asks the candidate to provide a relevant answer — maintaining interview quality throughout.",
    feature5Title: "Real-Time Voice Analysis",
    feature5Desc: "AI simultaneously analyzes answer content, vocal tone, fluency, and competency alignment. A detailed competency report is ready the moment the call ends.",
    feature6Title: "Fully Automated Pipeline",
    feature6Desc: "Evaluate hundreds of candidates simultaneously without any recruiter involvement. All calls are recorded and reported automatically.",
    ctaTitle: "Try Phone AI Interview",
    ctaSubtitle: "Request a demo now and transform your hiring process",
    ctaButton: "Request a Demo",
    faqTitle: "Phone AI Interview — Frequently Asked Questions",
    faq1Q: "How does the phone AI interview work?",
    faq1A: "HireThink AI automatically calls the candidate from 0850 307 80 61. The moment the candidate answers, a personalized interview begins. AI asks questions verbally, evaluates answers in real time, and generates a competency report at the end of the call.",
    faq2Q: "Can the candidate ask to hear a question again?",
    faq2A: "Yes. If the candidate didn't hear or understand a question, they can verbally request it again. AI will repeat the question clearly and calmly.",
    faq3Q: "What if the candidate isn't available at the time of the call?",
    faq3A: "The candidate can state a preferred day and time verbally. AI creates the appointment and automatically calls back at the scheduled time.",
    faq4Q: "What happens when an answer is off-topic?",
    faq4A: "AI detects when a response is unrelated to the question and politely asks the candidate to provide a relevant answer — maintaining interview quality throughout.",
    faq5Q: "Are phone interviews recorded?",
    faq5A: "Yes. All calls are recorded in a GDPR/KVKK-compliant manner and fully reported. Recruiters can replay the conversation and review the competency report after the interview."
  },
  textInterview: {
    heroTitle1: "Text",
    heroTitle2: "AI Interview",
    windowTitle: "HireThink Text AI Interview",
    heroSubtitle: "Structured text interviews for early-stage screening—powered by AI rubric scoring.",
    imageAlt: "Text AI interview experience",
    floatBadge1Title: "Low Cost",
    floatBadge1Desc: "Best price",
    floatBadge2Title: "Unlimited Candidates",
    floatBadge2Desc: "At the same time",
    floatBadge3Title: "Accessible",
    floatBadge3Desc: "Access from anywhere",
    featuresTitle: "Text Interview Features",
    featuresSubtitle: "Early screening with low-friction text interviews",
    feature1Title: "Access from Anywhere",
    feature1Desc:
      "Join from any device, anywhere; a perfect solution even for weak internet connections and low hardware requirements.",
    feature2Title: "Question Variety",
    feature2Desc:
      "Write your own questions or have AI generate them. Evaluate candidates with different levels and different question types.",
    feature3Title: "Anomaly Detection",
    feature3Desc:
      "Reports unusual situations by running similarity checks, AI-generated answer detection, and analyzing browser activity—keeps everything on record.",
    feature4Title: "Language Flexibility",
    feature4Desc:
      "Written interview support in 30+ languages, including Turkish, English, German, French, Spanish, Italian, Portuguese, Dutch, Polish, Czech, Swedish, Norwegian, and Danish.",
    feature5Title: "Secure & KVKK Compliant",
    feature5Desc:
      "All interview recordings are stored encrypted on secure servers. Fully compliant with KVKK and GDPR standards.",
    feature6Title: "Detailed Analytics Reports",
    feature6Desc:
      "Make data-driven decisions with competency-based scoring, sentiment analysis, and comparative evaluations.",
    ctaTitle: "Try Text AI Interview",
    ctaSubtitle: "Request a demo now and transform your hiring process",
    ctaButton: "Request a Demo",
    aboutTitle: "What Is a Text AI Interview?",
    aboutText: "A text AI interview lets candidates answer questions by typing directly in the browser — no camera or microphone required. AI analyzes the content, language quality, and competency alignment of each written response to score candidates. It's especially well suited to roles where written communication is critical, such as content, customer service, legal, and software positions.",
    faqTitle: "Text AI Interview — Frequently Asked Questions",
    faq1Q: "How does text AI interview work?",
    faq1A: "Candidates receive an interview link by email and type their answers to questions directly in the browser. AI evaluates the written responses by competency and generates a ranked scoring report.",
    faq2Q: "What roles is text interview best suited for?",
    faq2A: "Text AI interview is ideal for roles where written communication is critical — such as content creation, customer service, legal, finance, software, and data analysis positions.",
    faq3Q: "How does AI evaluate written answers?",
    faq3A: "AI analyzes the content, language quality, logical coherence, and alignment with target competencies. Each answer is scored and an overall competency report is generated.",
    faq4Q: "What does a candidate need to join a text interview?",
    faq4A: "Just an internet-connected device. No camera or microphone is needed — the candidate types all responses via keyboard."
  },

  peerInterviewPage: {
    heroTitle1: "Peer-to-Peer",
    heroTitle2: "Selection",
    windowTitle: "HireThink Peer Interview",
    heroSubtitle: "Let candidates who have advanced to the final stage be selected by voting from their potential team members.",
    imageAlt: "Peer interview experience",
    floatBadge1Title: "Team Voting",
    floatBadge1Desc: "Team member selection",
    floatBadge2Title: "Anonymous System",
    floatBadge2Desc: "Fair evaluation",
    floatBadge3Title: "Choice of Giants",
    floatBadge3Desc: "Used by global giants",
    featuresTitle: "Peer Interview Features",
    featuresSubtitle: "The team knows best what the team needs - an equal and fair selection process",
    feature1Title: "Anonymous Candidate Information",
    feature1Desc: "Information about candidates who have advanced to the final stage is uploaded to the system anonymously. Each team member can view candidates through a link sent to potential team members.",
    feature2Title: "Comparison and Scoring",
    feature2Desc: "Team members can review and compare candidate information in detail. They score each candidate to identify the most suitable team member.",
    feature3Title: "Anonymous Q&A",
    feature3Desc: "Team members can ask candidates questions anonymously if they wish. When a question is asked, the candidate receives an SMS notification and can log in to answer anonymously.",
    feature4Title: "Transparent Process",
    feature4Desc: "Answers given by candidates are visible to all team members. This ensures everyone has the same information and enables a fairer evaluation.",
    feature5Title: "Team Voting",
    feature5Desc: "After all evaluations are completed, the scores given by team members are aggregated and the most suitable candidate is selected. Everyone has equally selected their team member.",
    feature6Title: "Method of Global Giants",
    feature6Desc: "This method, used by major companies like Google, Stripe, LinkedIn, GitLab, Atlassian, and Amazon, is preferred because the team knows best what the team needs.",
    ctaTitle: "Try Peer Interview",
    ctaSubtitle: "Request a demo now and start your team-based selection process",
    ctaButton: "Request a Demo",
    aboutTitle: "What Is a Peer Interview?",
    aboutText: "A peer interview is a structured model where a candidate is evaluated not only by a recruiter but also by the team members they will work with. Each team member reviews anonymized candidate information and scores independently; results are combined into a single consensus report. Used by companies like Google, Stripe, and LinkedIn, this method ensures the hiring decision is owned by the team.",
    faqTitle: "Peer Interview — Frequently Asked Questions",
    faq1Q: "What is a peer interview?",
    faq1A: "A peer interview is a structured model where a candidate is evaluated not only by the recruiter but also by the team members they will work with. Each team member scores independently from their own perspective, and results are combined into a single consensus report.",
    faq2Q: "How are team members' evaluations combined?",
    faq2A: "Each evaluator scores independently against the same competency criteria. HireThink combines these scores into a single consensus score and comparative report, so no single subjective opinion dominates the decision.",
    faq3Q: "What roles is peer interview best suited for?",
    faq3A: "Peer interview is especially valuable for roles where team fit is critical — such as software teams, sales teams, and management positions — ensuring the hiring decision is owned by the team.",
    faq4Q: "How many team members can take part in an evaluation?",
    faq4A: "An unlimited number of team members can be invited to the evaluation process within your plan limits; each scores independently from their own panel and can send anonymous questions to the candidate via SMS."
  },

  cvScoring: {
    heroTitle1: "AI-based",
    heroTitle2: "CV Scoring",
    windowTitle: "HireThink CV Scoring",
    heroSubtitle:
      "Collect all applications on a single page, evaluate CVs in different formats with AI, and score them based on your criteria.",
    imageAlt: "CV Scoring Dashboard",
    floatBadge1Title: "Fast Analysis",
    floatBadge1Desc: "Scoring in seconds",
    floatBadge2Title: "Tailored to Your Needs",
    floatBadge2Desc: "Create criteria from your job post",
    floatBadge3Title: "Detailed Report",
    floatBadge3Desc: "Comprehensive analysis",
    featuresTitle: "CV Scoring Features",
    featuresSubtitle: "Speed up your hiring process with AI-based CV evaluation",
    feature1Title: "Easy Apply, Easy Tracking",
    feature1Desc:
      "Collect all applications on one platform and track them easily. View and manage application statuses in real time.",
    feature2Title: "Detailed Analyses",
    feature2Desc:
      "Get comprehensive analysis reports for each CV. Evaluate in detail based on skills, experience, education, and other criteria.",
    feature3Title: "Bulk CV Upload",
    feature3Desc:
      "Evaluate all candidates with AI—either by redirecting applications or uploading CVs in bulk.",
    feature4Title: "Export Reports",
    feature4Desc: "Download analysis results as PDF. Share with your team and archive reports.",
    feature5Title: "Scoring by Job Post Criteria",
    feature5Desc:
      "Create AI-generated criteria and weights for each job post, automatically score CVs, and quickly find the best-fit candidates.",
    feature6Title: "Growth Suggestions",
    feature6Desc:
      "Get personalized growth suggestions for your candidates; spot what’s missing for the role in your job post. Plus, help candidates improve fast with recommended courses and resources—and bring them to the right level for your company.",
    faqTitle: "CV Scoring — Frequently Asked Questions",
    faq1Q: "How does AI CV scoring work?",
    faq1A: "AI compares job requirements against each candidate's CV and assigns a match score. Skills, experience, education, and keywords are analyzed automatically, and candidates are ranked for the recruiter.",
    faq2Q: "Which file formats are supported?",
    faq2A: "HireThink CV scoring supports PDF, Word (DOCX), image files (JPG, PNG), and many other formats. Bulk CV uploads are also supported.",
    faq3Q: "What criteria does AI use to evaluate CVs?",
    faq3A: "AI analyzes job-role alignment, core competencies, experience duration and quality, education level, and keyword match. All criteria are weighted and combined into a single ranking score.",
    faq4Q: "How much does CV scoring reduce screening time?",
    faq4A: "HireThink CV scoring reduces manual screening time by up to 80%. Each CV is analyzed and scored within 3 minutes."
  },

  ats: {
    heroTitle1: "ATS",
    heroTitle2: "Applicant Tracking System",
    windowTitle: "HireThink ATS",
    heroSubtitle:
      "Collect all applications on a single platform, get the most out of your talent pool, and automate post-offer processes. Manage every stage of your hiring pipeline from one central system.",
    imageAlt: "ATS Dashboard",
    floatBadge1Title: "Talent Pool",
    floatBadge1Desc: "Smart matching",
    floatBadge2Title: "Process Tracking",
    floatBadge2Desc: "Automated management",
    floatBadge3Title: "Central Platform",
    floatBadge3Desc: "Manage from one place",
    featuresTitle: "ATS Features",
    featuresSubtitle: "A powerful ATS that optimizes your hiring process",
    feature1Title: "Central Application Management",
    feature1Desc:
      "Gather all job posts and applications on a single platform. Easily manage applications coming from different sources.",
    feature2Title: "Talent Pool",
    feature2Desc:
      "View the current skills and experience of candidates who’ve applied to other roles. Instantly see if they fit your other openings and discover the best matches with AI-based analysis.",
    feature3Title: "Process Tracking",
    feature3Desc:
      "Manage all post-offer processes for your hires from one platform. Track online onboarding documents, contract sending, onboarding preparation, and other administrative steps in a single system—never miss a stage.",
    feature4Title: "Candidate Tracking",
    feature4Desc:
      "Track application status, interview results, and evaluation notes for each candidate in one place.",
    feature5Title: "Team Collaboration",
    feature5Desc:
      "Share notes with your team, compare candidates, and make joint decisions.",
    feature6Title: "Integrations",
    feature6Desc:
      "Integrate with your existing HR systems and optimize your workflow.",
    aboutTitle: "What Is an ATS?",
    aboutText: "An ATS (Applicant Tracking System) lets you manage job postings, candidate applications, and hiring workflows in a single platform. HireThink ATS is fully integrated with AI interviews, CV scoring, and competency assessments, so you can manage your entire candidate pipeline from one dashboard.",
    faqTitle: "ATS — Frequently Asked Questions",
    faq1Q: "What is an ATS and what does it do?",
    faq1A: "An ATS (Applicant Tracking System) lets you manage job postings, candidate applications, and hiring workflows in a single platform. HireThink ATS is fully integrated with CV scoring, interviews, and assessments.",
    faq2Q: "Can HireThink ATS integrate with my existing HR software?",
    faq2A: "HireThink comes with its own built-in ATS. API-based integration with existing HR software is also available. Contact info@hirethink.ai for details.",
    faq3Q: "How is the candidate pipeline managed?",
    faq3A: "Within the ATS you can create per-job candidate pools, move candidates through stages, add notes, and collaborate with team members. All data is monitored from a centralized dashboard."
  },

  assessments: {
    badgeLabel: "Psychometric Assessments",
    heroTitle1: "Psychometric",
    heroTitle2: "Assessment Center",
    heroSubtitle:
      "Measure candidate potential with Personality & Work Style, Cognitive capacity, and Situational Judgment (SJT) tests—powered by AI algorithms built on globally recognized assessment principles, delivered in minutes, objectively and consistently.",
    windowTitle: "HireThink Psychometric Assessment",
    heroImageAlt: "Psychometric assessment screen",
    badge1Title: "Recognized Methodology",
    badge1Desc: "Assessment principles used worldwide",
    badge2Title: "Multi-Dimensional",
    badge2Desc: "Personality, cognitive, SJT",
    badge3Title: "Standard Flow",
    badge3Desc: "Invite, test, report, share",
    sectionLabel: "Smart Modules",
    sectionTitle: "Psychometrics + competency in one panel",
    sectionSubtitle:
      "Blend Personality & Work Style, Cognitive, and SJT tests with competency and case flows to speed up hiring decisions.",
    module1Title: "Psychometric Pack",
    module1Desc:
      "Map personality, values, and work styles with modern inventories, and complement them with cognitive speed and attention metrics.",
    module1Bullets: [
      "Personality & work style map",
      "Cognitive speed, attention, working memory",
      "Scores aligned to norms and role thresholds"
    ],
    module2Title: "Flow Automation",
    module2Desc:
      "AI suggests the right test pack and question set by role and level; you approve and send invites in one click.",
    module2Bullets: [
      "Role/level presets and templates",
      "Bulk invites & secure sessions",
      "Live completion tracking"
    ],
    module3Title: "Reporting & Security",
    module3Desc:
      "Psychometric and competency scores in one report, with detailed AI-generated analysis and insights; KVKK/GDPR-compliant storage, shareable links, and concise summaries.",
    module3Bullets: [
      "Role fit and risk alerts",
      "Psychometric summary & insight cards",
      "Compliant access and audit trail"
    ],
    pillarsLabel: "Psychometric Dimensions",
    pillarsTitle: "Comprehensive measurement on three axes",
    pillarsSubtitle:
      "Each test pack merges Personality & Work Style, Cognitive capacity, and Situational Judgment (SJT) scores in a single view.",
    pillar1Title: "Personality & Work Style",
    pillar1Desc:
      "Measure work values, motivation, team style, and stress coping for the role.",
    pillar1Bullets: [
      "Five-factor personality scales",
      "Leadership, customer focus, collaboration profiles",
      "Strength & risk signals mapped to the role"
    ],
    pillar2Title: "Cognitive",
    pillar2Desc:
      "Score working memory, attention, and numerical/verbal reasoning speed with short, adaptive tests.",
    pillar2Bullets: [
      "Time-based scores with speed/accuracy balance",
      "Noise tolerance and focus metrics",
      "Norm group and threshold comparisons"
    ],
    pillar3Title: "Situational Judgment (SJT)",
    pillar3Desc:
      "Evaluate decision-making, value alignment, and prioritization in real job scenarios.",
    pillar3Bullets: [
      "Localized scenarios tailored to the role",
      "Weighted scores per chosen actions",
      "Bias-reducing, standardized flow"
    ],
    flowLabel: "Flow",
    flowTitle: "Launch a psychometric flow in minutes",
    flowSubtitle:
      "Pick the role, approve the AI-recommended pack, send the invite, get a single report.",
    flow1Title: "Role & Level Setup",
    flow1Desc:
      "Select role, seniority, and weighting between competency and psychometrics.",
    flow2Title: "Pack Selection",
    flow2Desc:
      "Bundle Personality & Work Style + Cognitive + SJT tests for the role/level; you control duration and question counts.",
    flow3Title: "Secure Invite",
    flow3Desc:
      "One-click invites; identity checks, proctoring, and anomaly controls for transparent sessions.",
    flow4Title: "Report & Share",
    flow4Desc:
      "Psychometric summary cards, benchmarks, and growth advice in one report; PDF and shareable link.",
    aiAdvantageLabel: "The AI Advantage",
    aiAdvantageTitle: "Why assess with AI?",
    aiAdvantageSubtitle:
      "Our algorithms, built on assessment principles used worldwide, score tests far faster, cheaper, and more consistently than traditional methods.",
    highlight1Title: "Results in Minutes",
    highlight1Desc:
      "AI scores and analyzes tests the moment they're completed—turning a process that can take days of manual review into minutes.",
    highlight2Title: "Lower Cost",
    highlight2Desc:
      "Far more cost-effective than outside consultants or expert assessors—evaluate unlimited candidates to the same standard.",
    highlight3Title: "No Human Error or Bias",
    highlight3Desc:
      "Standardized algorithmic scoring removes errors caused by assessor fatigue, inattention, and unconscious bias.",
    ctaLabel: "Request Demo",
    ctaTitle: "Start psychometric assessment now",
    ctaSubtitle:
      "Run Personality & Work Style, Cognitive, and SJT tests from one panel with standardized reports.",
    ctaPrimary: "Request Demo",
    ctaSecondary: "Talk to Sales",
    faqTitle: "Competency Assessments — Frequently Asked Questions",
    faq1Q: "How do competency assessment tests work?",
    faq1A: "Candidates receive an online test link. Tests measure cognitive ability, personality, role fit, and situational judgment. Results are automatically reported and combined with other evaluation data.",
    faq2Q: "What types of assessments are available?",
    faq2A: "HireThink's assessment module includes cognitive ability tests, scientifically validated personality inventories, role-fit analyses, and written/verbal competency questions.",
    faq3Q: "When are test results ready?",
    faq3A: "Results are available instantly after the candidate completes the test. The competency report and score summary are immediately accessible to the recruiter.",
    faq4Q: "Are personality tests scientifically validated?",
    faq4A: "HireThink's psychometric assessments are aligned with scientifically-grounded models. Results are intended to complement — not replace — interview and CV data for well-rounded hiring decisions."
  },
  training: {
    heroTitle1: "Employee",
    heroTitle2: "Training & Onboarding",
    windowTitle: "HireThink Training Modules",
    heroSubtitle: "Manage mandatory training for your employees with AI-based modules. Optimize your training processes with progress tracking, assessment tests, and detailed reporting.",
    imageAlt: "Training Modules Dashboard",
    floatBadge1Title: "Mandatory Training",
    floatBadge1Desc: "Team-focused",
    floatBadge2Title: "Instant Tests",
    floatBadge2Desc: "In-training assessment",
    floatBadge3Title: "1000+ Avatars",
    floatBadge3Desc: "Various options",
    featuresTitle: "Training Module Features",
    featuresSubtitle: "AI-based training platform that manages mandatory training for your employees",
    feature2Title: "Personalized Training Plans",
    feature2Desc: "Create training options according to your company needs.",
    feature1Title: "1000+ Avatar Options",
    feature1Desc: "Choose from a wide avatar library. Select the avatar that best fits your company and topic.",
    feature3Title: "Assessment Tests",
    feature3Desc: "Instantly evaluate whether employees understand the topic with tests that appear in the middle of the video during training. Measure knowledge level with post-training mastery tests.",
    feature4Title: "Progress Tracking",
    feature4Desc: "Track your employees' training progress in detail. View completion status, test results, and participation rates.",
    feature5Title: "Reporting",
    feature5Desc: "Analyze employee performance with detailed training reports. View which trainings are completed, test success rates, and development areas.",
    feature6Title: "Focused Learning",
    feature6Desc: "Make training videos non-skippable and non-playable in the background. Ensure your team members learn with full focus and maximize training effectiveness.",
    coursesBadge: "Live Training Catalog",
    coursesTitle: "Our Training Programs",
    coursesSubtitle: "These aren't digital modules — they are real corporate development programs delivered live on our online training platform by our expert instructors.",
    coursesCategory1: "HR & Analytics",
    coursesCategory1Item1: "HR Specialist Training",
    coursesCategory1Item2: "HR Analytics Training",
    coursesCategory1Item3: "Excel and AI Training",
    coursesCategory1Item4: "Excel and AI Training for HR",
    coursesCategory2: "Leadership & Management Programs",
    coursesCategory2Item1: "Team Leader Development Program",
    coursesCategory2Item2: "Project Leader and Manager Development Program",
    coursesCategory2Item3: "Prioritization and Work Planning",
    coursesCategory2Item4: "Sustainable Performance in Business Processes",
    coursesCategory2Item5: "Crisis Management",
    coursesCategory3: "Personal & Team Development",
    coursesCategory3Item1: "Team Awareness and Collaboration",
    coursesCategory3Item2: "Building Quality Awareness",
    coursesCategory3Item3: "Change and Personal Development",
    coursesCategory3Item4: "Communication Management",
    coursesCategory3Item5: "Motivation and Employee Engagement",
    coursesCategory3Item6: "Documentation and Reporting",
    coursesFootnote: "Can't find the training you're looking for? We'll prepare custom content for your needs.",
    coursesCta: "View Training Calendar",
    faqTitle: "Training & Onboarding — Frequently Asked Questions",
    faq1Q: "Are the training modules recorded or live?",
    faq1A: "The corporate development programs in HireThink's training catalog are not recorded digital modules — they are delivered live on our online training platform by expert instructors. Mandatory in-house training, on the other hand, is managed through AI-based video modules with instant assessment tests.",
    faq2Q: "How is employee training progress tracked?",
    faq2A: "Each employee's completion status, test results, and participation rate are tracked live from the dashboard. Training videos are made non-skippable to ensure full attention.",
    faq3Q: "What training categories are offered?",
    faq3A: "Training is organized into HR & Analytics, Leadership & Management Programs, and Personal & Team Development categories; custom content can be prepared for topics not already in the catalog.",
    faq4Q: "Is there an assessment at the end of training?",
    faq4A: "Yes. In-video tests measure comprehension as employees progress, and a comprehensive mastery test at the end measures overall knowledge, with results fully reported."
  },

  nav: {
    cvScoring: "CV Scoring",
    interviews: "Interviews",
    peerInterview: "Peer Interview",
    assessments: "Assessments",
    ats: "ATS",
    training: "Training",
    pricing: "Pricing",
    contact: "Contact",
    login: "Log In",
    getStarted: "Log In"
  },

  nav_dropdown: {
    premiumLiveAI: "Premium Live AI Interview",
    standardVideoAI: "Standard Video AI Interview",
    voiceInterview: "Voice Interview",
    textInterview: "Text Interview",
    whatsappInterview: "WhatsApp Interview",
    phoneInterview: "Phone Interview",
    interviewObserver: "AI Interview Observer"
  },

  hero: {
    headline1: "Real",
    headline2: "AI Interview",
    talentHeadline1: "AI-based",
    talentHeadline2: "Job Prep Coach",
    subheadline: "From job application to hiring—upgrade your processes with AI",
    talentSubheadline:
      "Practice realistic interviews tailored to your role, get instant analysis, strengthen your CV, and join interviews with confidence.",
    toggleHiring: "I'm an Employer",
    toggleTalent: "I'm a Candidate",
    toggleComingSoon: "coming soon",
    heroBadge: "Meet the best and most comprehensive AI HR product in the industry",
    ctaHiring: "Get Started",
    ctaTalent: "Get Started",
    talentExternalLink: "Open candidate platform",
    reviews: "reviews",
    badge1Title: "Competency-Focused",
    badge1Desc: "Evaluate based on concrete competencies.",
    badge2Title: "Standardized Interviews",
    badge2Desc: "Use the same questions and criteria for every candidate.",
    badge3Title: "Data-Driven",
    badge3Desc: "Trust insights and criteria—not gut feeling.",
    step1Title: "Choose the Package That Fits You",
    step1Desc: "",
    step2Title: "Create Your Job Post",
    step2Desc: "",
    step3Title: "The best-fit candidates are ready—with scored CVs and completed interviews!",
    step3Desc: "",
    talentOffer1Title: "CV Analysis",
    talentOffer1Desc:
      "When you upload your CV, our system analyzes it and identifies areas to improve—from missing information to weak phrasing, unnecessary details, and formatting inconsistencies. Then it provides clear, personalized suggestions to make your CV more professional and impactful.",
    talentOffer2Title: "Interview Preparation",
    talentOffer2Desc:
      "Practice realistic AI interviews tailored to your role and target company—video, voice, or text. Get instant feedback, see example improvements for weak answers, benchmark against average scores, and walk into interviews with confidence.",
    talentOffer3Title: "Role-Based Growth",
    talentOffer3Desc:
      "See your competency gaps for your target role with score-based insights; build a weekly improvement path with personalized micro-tasks, curated resources, and practice sets—both technical and behavioral.",
    dashboardPreview: "Dashboard Preview",
    totalEvaluations: "Total Applications",
    thisMonth: "this month",
    interviewCompleted: "Interview Completed",
    minutesAgo: "5 minutes ago"
  },

  stats: {
    stat1Value: "24/7",
    stat1Label: "Interview Experience",
    stat2Value: "3x",
    stat2Label: "Time Saved",
    stat3Value: "97%",
    stat3Label: "Consistency Rate"
  },

  why: {
    title: "Why HireThink?",
    reason1Title: "Reduce Costs",
    reason1Desc: "Cut the total cost of traditional interview processes by up to 4x.",
    reason2Title: "Increase Efficiency",
    reason2Desc:
      "Reach the right candidates faster with AI-based pre-screening. Shorten time-to-hire for qualified candidates.",
    reason3Title: "Objective Evaluation",
    reason3Desc: "Make the best decisions with bias-free, standardized evaluations."
  },

  features: {
    title: "Hiring AI Solutions",
    subtitle: "Start AI optimization for your HR processes with HireThink.",
    feature1Title: "AI-based CV Scoring",
    feature1Desc:
      "Collect all applications on one page, evaluate CVs in different formats with AI—either by redirecting applications or uploading in bulk—and score them based on your criteria.",
    feature2Title: "AI Hiring Interview",
    feature2Desc:
      "Interview hundreds of candidates in a day with an AI-based virtual assistant. View results within minutes, detect unusual situations with advanced anomaly checks, and review recordings for deeper verification.",
    feature3Title: "Accessible Interviews",
    feature3Desc:
      "Provide a fully accessible interview experience for candidates with speech or hearing impairments, using AI that understands sign language and supports text communication.",
    feature4Title: "Foreign Language Proficiency Interview",
    feature4Desc:
      "Access the global talent pool with interview support in Turkish, English, German, Spanish, French, Italian, and many more—evaluate language proficiency with standardized, objective criteria.",
    feature5Title: "Competency Analysis",
    feature5Desc: "Detailed and objective candidate evaluation across 14+ competency sets like communication, leadership, and problem solving.",
    feature6Title: "Psychometric Assessments",
    feature6Desc:
      "Make more accurate and objective hiring decisions by measuring personality and cognitive/behavioral tendencies through psychometric tests.",
    feature7Title: "Training Modules",
    feature7Desc:
      "Identify candidates’ gaps and development areas with AI-based modules and build your training plans.",
    feature8Title: "Applicant Tracking System (ATS)",
    feature8Desc:
      "Track all candidates on a single platform and manage your entire pipeline—from CV scoring to hiring—easily.",
    feature9Title: "Promotion Interviews & Case Studies",
    feature9Desc:
      "Discover internal talent with AI-based promotion evaluations and case studies.",
    feature10Title: "AI Candidate Recommendation System",
    feature10Desc:
      "Don’t limit yourself to applicants only—discover the best-fit candidates for your job post and send offers using AI.",
    feature11Title: "Complaint & Suggestions Module",
    feature11Desc:
      "Continuously improve HR processes by collecting structured feedback from employees and customers.",
    feature12Title: "AI Exit Job Interviews",
    feature12Desc:
      "Understand employee experience, collect valuable feedback, and support organizational improvement."
  },

  howItWorks: {
    title: "How It Works",
    subtitle: "Optimize your hiring process in minutes",
    cvScoringTitle: "CV Scoring Module",
    cvStep1Title: "Publish Your Job Post",
    cvStep1Desc:
      "Redirect your current job post to the HireThink application page or evaluate candidates with AI by uploading CVs in bulk.",
    cvStep2Title: "View CV Evaluations",
    cvStep2Desc: "See CV scores of incoming applications within seconds.",
    cvStep3Title: "Send Interview Invites",
    cvStep3Desc: "Send bulk interview invitations to your selected candidates.",
    interviewTitle: "AI Interview",
    intStep1Title: "Create Your Interview",
    intStep1Desc:
      "Define your question set, competencies, questions, date range, and other settings with AI—and configure your interview flow.",
    intStep2Title: "Send Bulk Invites",
    intStep2Desc:
      "Invite candidates with one click from CV scoring or other systems, or import candidates via Excel and send invites.",
    intStep3Title: "View Analyses",
    intStep3Desc:
      "Review scores and analyses of completed interviews from the dashboard, compare candidates, and export results."
  },

  competencies: {
    title: "Competency Sets",
    subtitle: "Select the right competencies for your role and reach the right candidates with competency analysis.",
    communication: "Communication Skills",
    teamwork: "Teamwork",
    problemSolving: "Problem Solving",
    decisionMaking: "Decision Making",
    leadership: "Leadership",
    adaptability: "Adaptability / Flexibility",
    responsibility: "Ownership",
    planning: "Planning & Organization",
    goalOrientation: "Goal Orientation",
    personalDevelopment: "Personal Development",
    customerFocus: "Customer Focus",
    analyticalThinking: "Analytical Thinking",
    innovation: "Innovation",
    ethics: "Ethics & Values Orientation",
    languagesTitle: "Multi-Language Support",
    languagesSubtitle: "Create interviews in different languages and access the global talent pool.",
    turkish: "Turkish",
    english: "English",
    german: "German",
    french: "French",
    spanish: "Spanish",
    italian: "Italian",
    portuguese: "Portuguese",
    dutch: "Dutch",
    polish: "Polish",
    czech: "Czech",
    swedish: "Swedish",
    norwegian: "Norwegian",
    danish: "Danish",
    romanian: "Romanian",
    hungarian: "Hungarian",
    finnish: "Finnish",
    croatian: "Croatian",
    slovenian: "Slovenian",
    slovak: "Slovak",
    catalan: "Catalan",
    estonian: "Estonian",
    latvian: "Latvian",
    lithuanian: "Lithuanian",
    albanian: "Albanian",
    bosnian: "Bosnian",
    macedonian: "Macedonian",
    maltese: "Maltese",
    luxembourgish: "Luxembourgish",
    afrikaans: "Afrikaans",
    azerbaijani: "Azerbaijani",
    indonesian: "Indonesian",
    malay: "Malay",
    maori: "Maori",
    tagalog: "Tagalog",
    vietnamese: "Vietnamese",
    languagesNote:
      "With our AI-based infrastructure, we support 30+ languages. You can instantly train our AI from the admin panel for words whose pronunciation you don’t like.",
    moreLanguagesChip: "+ More languages",
    imageAlt: "Competency sets visual",
    analysisTitle: "Flexible Analysis Configuration",
    qaAnalysis: "Q&A Analysis",
    talentAnalysis: "Competency Analysis",
    analysisNote:
      "With flexible analysis configuration, you can set different competency weights for student programs and senior-level hiring."
  },

  integrations: {
    title: "Integrate with Your Favorite Tools",
    subtitle: "Easily integrate into your existing workflows and boost productivity.",
    seeAll: "See All Integrations"
  },

  testimonials: {
    title: "Fast. Reliable. Affordable.",
    subtitle: "What our customers say",
    quote1:
      "With HireThink, we accelerated our interview processes by 60%. Now we can reach the right candidates much faster.",
    author1: "Ayşe Yılmaz",
    role1: "HR Director",
    company1: "TechCorp",
    quote2:
      "AI-based evaluations provide unbiased and consistent results. It helps us make the best decisions.",
    author2: "Mehmet Kaya",
    role2: "Recruitment Manager",
    company2: "FinanceHub",
    quote3:
      "It’s incredibly easy to use and the reports are very detailed. Our whole team is very happy.",
    author3: "Zeynep Demir",
    role3: "HR Manager",
    company3: "StartupX",
    trustedBy: "Trusted By"
  },

  cta: {
    headline1: "Ready to",
    headline2: "Transform",
    headline3: "Your Hiring Process?",
    subtitle: "Start using HireThink now and discover the future of hiring.",
    button: "Get Started",
    orContact: "or contact us →"
  },

  footer: {
    email: "info@hirethink.ai",
    description: "Optimize your hiring processes with AI-based interview solutions.",
    kvkkCompliant: "KVKK Compliant",
    iso27001: "ISO 27001",
    about: "About",
    pricing: "Pricing",
    blog: "Blog",
    careers: "Careers",
    contact: "Contact",
    faq: "FAQ",
    newsletter: "Newsletter",
    solutions: "Solutions",
    premiumInterview: "Premium Live AI Interview",
    standardInterview: "Standard Video AI Interview",
    voiceInterview: "Voice AI Interview",
    textInterview: "Text AI Interview",
    peerInterview: "Peer Interview",
    whatsappInterview: "WhatsApp AI Interview",
    phoneInterview: "Phone AI Interview",
    interviewObserver: "AI Interview Observer",
    cvScoring: "CV Scoring",
    videoInterview: "Video Interview",
    avatarInterview: "AI Avatar Interview",
    cvAnalysis: "CV Analysis",
    interviewPrep: "Interview Preparation",
    roleGrowth: "Role-Based Growth",
    legal: "Legal",
    terms: "Terms of Use",
    privacy: "Privacy Policy",
    kvkk: "KVKK",
    cookies: "Cookie Policy",
    distanceSales: "Distance Sales Agreement",
    deliveryReturn: "Delivery and Return Terms",
    copyright: "© 2025 HireThink Artificial Intelligence Technologies Inc. All rights reserved.",
    address: "Bilişim Vadisi, Ayazağa, Vadi Istanbul Park Etabı, Kemerburgaz Caddesi D:7A Blok, 34475 Sarıyer/İstanbul",
    youtube: "YouTube",
    linkedin: "LinkedIn",
    emailLabel: "Email"
  },

  contact: {
    title: "Contact Us",
    subtitle: "We’ll get back to you as soon as possible",
    pageTitle: "Contact",
    pageSubtitle: "Reach out for questions, suggestions, or partnership opportunities.",
    infoTitle: "Contact Information",
    formTitle: "Contact Form",
    formDescription: "Click the button below to open the contact form and send your message.",
    openForm: "Open Contact Form",
    email: "Email",
    phone: "Phone",
    address: "Address",
    fullAddress:
      "Bilişim Vadisi, Ayazağa, Vadi Istanbul Park Etabı, Kemerburgaz Caddesi D:7A Blok, 34475 Sarıyer/İstanbul",
    vkn: "Tax ID Number",
    companyName: "Company",
    fullName: "Full Name",
    fullNamePlaceholder: "Your Full Name",
    emailPlaceholder: "example@email.com",
    phonePlaceholder: "0555 123 45 67",
    employeeCount: "Number of Employees",
    employeeCountPlaceholder: "Select employee count",
    submit: "Send",
    submitting: "Sending...",
    successTitle: "Success!",
    successMessage: "Your message has been received. We’ll contact you shortly.",
    appointmentDescription: "Use our calendar page to book an appointment or schedule a meeting.",
    appointmentCta: "Book an Appointment"
  },
  calendar: {
    pageTitle: "Calendar",
    pageSubtitle: "Select a time range to create an appointment.",
    prev: "Previous",
    next: "Next",
    today: "Today",
    day: "Day",
    week: "Week",
    month: "Month",
    refresh: "Refresh",
    loading: "Loading calendar...",
    loadError: "Calendar data could not be loaded.",
    createTitle: "Create Appointment",
    createSubtitle: "Select a time range on the calendar to open the form.",
    openCreate: "Open New Appointment",
    formTitle: "New Appointment",
    formSubtitle: "Fill in the details for the selected time range.",
    customerName: "Full Name",
    customerEmail: "Email",
    customerPhone: "Phone",
    startTime: "Start Time",
    endTime: "End Time",
    duration: "Duration (min)",
    notes: "Notes",
    cancel: "Cancel",
    submit: "Save",
    submitting: "Saving...",
    createError: "Appointment could not be created.",
    emptySelection: "Select a valid time range.",
    halfHourError: "Times must be in 30-minute increments.",
    durationFixedError: "All appointments are 30 minutes.",
    durationFixedValue: "30 min",
    emailError: "Enter a valid email address.",
    phoneError: "Enter a valid phone number.",
    phoneCountry: "Country Code",
    phoneCountryTR: "Turkey (+90)",
    phoneCountryUS: "United States (+1)",
    phoneCountryGB: "United Kingdom (+44)",
    phoneCountryDE: "Germany (+49)",
    detailsTitle: "Appointment Details",
    noSelection: "Select an appointment to see details.",
    status: "Status",
    statusUnknown: "Unknown",
    unknownCustomer: "Candidate",
    instructionsTitle: "How It Works",
    instructionsText: "Click on the date and time you want to book, or drag to select a time range. The form opens automatically.",
    instructionsNote: "Duration options are limited to 30 and 60 minutes.",
    apiAlertTitle: "Warning",
    close: "Close"
  },
  pricing: {
    title: "Pricing",
    subtitle: "Choose the plan that fits your company size and optimize your hiring process.",
    monthlyPayment: "Monthly Billing",
    yearlyPayment: "Yearly Billing",
    savePercent: "(25% Off)",
    yearlyTotal: "Yearly total",
    starterName: "Starter",
    starterDesc: "Ideal for small businesses and entry-level hiring needs.",
    starterCta: "Get Started",
    professionalName: "Professional",
    professionalDesc: "A comprehensive solution for growing companies with high hiring volume.",
    professionalCta: "Get Started",
    professionalPopular: "Most Popular",
    enterpriseName: "Ultimate",
    enterpriseDesc: "Custom solutions for your team needs or unlimited usage.",
    enterpriseCta: "Contact Us",
    custom: "Custom",
    starterFeature1: "15 Avatar AI Interviews or 50 AI Interviews",
    starterFeature2: "500 CV Scorings",
    starterFeature3: "2 User Accounts",
    starterFeature4: "Unlimited Job Posts",
    starterFeature5: "Unlimited Question Creation",
    starterFeature6: "Competency Reporting",
    starterFeature7: "Anomaly Reports",
    starterFeature8: "Advanced Analytics",
    starterFeature9: "Average Candidate Results",
    starterFeature10: "Competency Sets",
    starterFeature11: "Peer Interview",
    starterFeature12: "ATS",
    starterFeature13: "Psychometric Assessments",
    starterFeature14: "Standard Support",
    starterFeature15: "Onboarding & Internal Training Module",
    starterFeature16: "Complaint & Satisfaction Management",
    starterFeature17: "Phone Interview",
    starterFeature18: "AI Reference Check",
    textInterview300: "300 Text Interviews",
    whatsappInterview: "WhatsApp Interview",
    aiCandidateSearch: "AI Candidate Search",
    aiOfferSuggestion: "AI Salary Offer Recommendation",
    professionalFeature1: "300 Avatar AI Interviews or 600 AI Interviews",
    professionalFeature2: "8,000 CV Scorings",
    professionalFeature3: "8 User Accounts",
    professionalFeature4: "Unlimited Job Posts",
    professionalFeature5: "Unlimited Question Creation",
    professionalFeature6: "Competency Reporting",
    professionalFeature7: "Anomaly Reports",
    professionalFeature8: "Advanced Analytics",
    professionalFeature9: "Average Candidate Results",
    professionalFeature10: "Competency Sets",
    professionalFeature11: "Peer Interview",
    professionalFeature12: "ATS",
    professionalFeature13: "Job closing reports",
    professionalFeature14: "Psychometric Assessments",
    professionalFeature15: "Priority Support",
    professionalFeature16: "Onboarding & Internal Training Module",
    professionalFeature17: "Complaint & Satisfaction Management",
    professionalFeature18: "Phone Interview",
    professionalFeature19: "AI Reference Check",
    enterpriseFeature1: "Solutions tailored to your needs",
    enterpriseFeature2: "Dedicated account manager",
    enterpriseFeature3: "Custom reporting",
    enterpriseFeature4: "Psychometric Assessments",
    enterpriseFeature5: "24/7 priority support",
    enterpriseFeature6: "Custom training & onboarding",
    enterpriseFeature7: "Custom integrations",
    enterpriseFeature8: "Company-Specific LLM Solutions",
    enterpriseFeature9: "AI-based Complaint & Satisfaction Management",
    enterpriseFeature10: "Onboarding & Internal Training Module",
    enterpriseFeature11: "Phone Interview",
    enterpriseFeature12: "AI Reference Check",
    perMonth: "/month"
  },

  talentProducts: {
    title: "Candidate Products",
    subtitle:
      "Three core AI-based steps for your job search: analyze, practice, improve. Each is personalized to your role and produces measurable feedback.",

    // Free AI CV Builder Section
    freeCvBadge: "100% Free",
    freeCvTitle: "Build Your Professional CV with AI — For Free",
    freeCvDesc:
      "Don't write your CV from scratch. Enter your details and let AI create an ATS-friendly, professional CV in the format recruiters look for. No credit card required, download it in minutes.",
    freeCvPoint1: "A ready CV in minutes",
    freeCvPoint2: "ATS-friendly professional templates",
    freeCvPoint3: "AI-powered wording suggestions",
    freeCvCta: "Create Your Free CV",
    freeCvHint: "Create it for free on isbulsun.com",

    // CV Analysis Section
    cvAnalysisBadge: "AI CV Analysis",
    cvAnalysisTitle: "CV Analysis",
    cvAnalysisDesc:
      "Scan your CV with AI; get separate scores for ATS compatibility, readability, impact strength, and role fit.",
    cvAnalysisDescLong:
      "Upload your CV to our AI-based analysis engine and get a comprehensive evaluation report in seconds. See your ATS readability, alignment with industry standards, impact-driven statements, and match rate with your target role in detail. Discover where competing candidates stand out, get AI-based suggested sentences for missing sections, and reshape your CV into the format recruiters want to see.",
    cvFeature1Title: "ATS Compatibility Score",
    cvFeature1Desc: "Learn how automated screening systems view your CV.",
    cvFeature2Title: "Industry Benchmarking",
    cvFeature2Desc: "Compare your CV with candidates in similar roles.",
    cvFeature3Title: "Smart Suggestions",
    cvFeature3Desc: "Get concrete improvement suggestions for each section.",
    cvFeature4Title: "Achievement Metrics",
    cvFeature4Desc: "Make your achievements measurable with impact-driven statements.",
    cvCheck1: "Line-by-line improvement suggestions",
    cvCheck2: "Readability and format analysis",
    cvCheck3: "Keyword optimization",
    cvMockTitle: "CV Analysis Report",
    cvMockSubtitle: "Software Engineer Position",
    cvMockScore: "Overall Score",
    cvScoreATS: "ATS Compatibility",
    cvScoreImpact: "Impact Strength",
    cvScoreReadability: "Readability",
    cvScoreRole: "Role Fit",
    cvSuggestionTitle: "AI Suggestion",
    cvSuggestionText:
      "\"I managed projects\" → Add concrete metrics like \"I led a 5-person team and delivered a project that increased efficiency by 40% in 3 months.\"",
    cvFloatLabel: "Conversion Rate Increase",
    cvFloatAI: "AI-based Analysis",

    // Interview Prep Section
    interviewPrepBadge: "AI Interview Practice",
    interviewPrepTitle: "Interview Preparation",
    interviewPrepDesc: "Practice with dynamic question sets based on real job scenarios.",
    interviewPrepDescLong:
      "Prepare yourself with interview simulations customized to your target position and company profile. Experience a real interview in video, voice, or text mode. AI provides instant feedback: evaluates your answer structure and content quality. Benchmark your performance against average candidate scores, get detailed scoring on technical accuracy and communication clarity, and boost your confidence with alternative sample answers and improvement suggestions for every weak response.",
    interviewFeature1Title: "Multiple Interview Modes",
    interviewFeature1Desc: "Practice in video, voice, or text formats.",
    interviewFeature2Title: "Instant AI Analysis",
    interviewFeature2Desc: "Your answers are evaluated in real time.",
    interviewFeature3Title: "Sample Answers",
    interviewFeature3Desc: "See alternative ideal answers for each question.",
    interviewFeature4Title: "Candidate Benchmarking",
    interviewFeature4Desc: "Compare your performance with other candidates.",
    interviewCheck1: "Question sets for 150+ roles",
    interviewCheck2: "Performance comparison with average scores",
    interviewCheck3: "Industry-specific interview scenarios",
    interviewRecording: "Recording",
    interviewQuestion: "Could you tell us about yourself and your career goals?",
    interviewModeVideo: "Video",
    interviewModeVoice: "Voice",
    interviewModeText: "Text",
    interviewFeedbackTitle: "Instant Evaluation",
    interviewScoreClarity: "Clarity",
    interviewScoreStructure: "Structure",
    interviewScoreConfidence: "Confidence",
    interviewFloatInstant: "Instant Feedback",
    interviewFloatQuestions: "Question Bank",

    // Role Growth Section
    roleGrowthBadge: "Career Growth",
    roleGrowthTitle: "Role-Based Growth",
    roleGrowthDesc: "See your competency gaps based on your target role.",
    roleGrowthDescLong:
      "Clearly see the competencies required to reach your career goal. AI compares your current skills with the requirements of your target role and creates a personalized growth roadmap. Progress systematically with weekly micro-tasks, curated resources, practice sets, and mini assessments. Close gaps in technical and behavioral competencies while strengthening your existing strengths.",
    growthFeature1Title: "Competency Map",
    growthFeature1Desc: "Visualize your strengths and improvement areas.",
    growthFeature2Title: "Curated Resources",
    growthFeature2Desc: "Training content and articles aligned with your goal.",
    growthFeature3Title: "Micro Tasks",
    growthFeature3Desc: "Build continuous improvement with daily practice.",
    growthFeature4Title: "Progress Tracking",
    growthFeature4Desc: "Track your growth with measurable metrics.",
    growthCheck1: "Personalized learning path",
    growthCheck2: "Weekly progress reports",
    growthCheck3: "Industry benchmark comparisons",
    growthMockTitle: "Growth Dashboard",
    growthMockSubtitle: "Product Manager Goal",
    skillTechnical: "Technical Knowledge",
    skillCommunication: "Communication",
    skillLeadership: "Leadership",
    skillProblem: "Problem Solving",
    skillAdaptability: "Adaptability",
    skillTeamwork: "Teamwork",
    weeklyTasksTitle: "This Week’s Tasks",
    task1: "Read the article on effective interview answers",
    task2: "Practice 2 behavioral questions",
    task3: "Complete the leadership case study",
    growthFloatProgress: "Weekly Progress",
    growthFloatResources: "50+ Resources"
  },

  blog: {
    title: "Blog",
    subtitle: "Up-to-date content about AI, hiring, and human resources",
    post1Title: "Transforming Hiring Processes with AI",
    post1Excerpt: "Discover how AI technologies are revolutionizing modern hiring processes.",
    post2Title: "CV Scoring: The New Way to Find the Right Candidate",
    post2Excerpt: "Evaluate thousands of applications in minutes with AI-based CV scoring systems.",
    post3Title: "The Future of Interview Technologies",
    post3Excerpt: "Explore how video, voice, and text AI interviews contribute to hiring processes.",
    categoryAI: "Artificial Intelligence",
    categoryHR: "Human Resources",
    categoryTechnology: "Technology",
    readMore: "Read More",
    comingSoon: "More content will be added soon. Stay tuned!"
  },

  career: {
    title: "Careers",
    subtitle: "Join the HireThink team and shape the future of AI technologies together",
    noOpeningsTitle: "There are no open positions right now",
    noOpeningsDesc:
      "We currently don’t have active job postings. However, you can follow us for future openings or send us your CV.",
    stayTuned: "Stay tuned",
    valuesTitle: "Our Values",
    value1Title: "Teamwork",
    value1Desc: "We build stronger solutions by working together.",
    value2Title: "Innovation",
    value2Desc: "We deliver innovative solutions through a culture of continuous learning and growth.",
    value3Title: "Excellence",
    value3Desc: "We aim for the highest quality standards in every project.",
    linkedinText: "Follow our LinkedIn page to stay informed about open positions",
    followLinkedIn: "Follow on LinkedIn",
    aiBadge: "NEW • AI-Powered Job Search",
    aiTitle1: "Find Your Dream Job",
    aiTitle2: "with AI",
    aiSubtitle: "Describe the job you're looking for in plain language. AI instantly ranks the best-matching positions for you.",
    aiPlaceholder: "E.g.: I'm looking for a React developer role in Istanbul with hybrid work, requiring 3+ years of experience...",
    aiButton: "Search with AI",
    aiSearching: "AI is analyzing job listings...",
    aiResultsCount: "positions found",
    aiNoResults: "No listings matched your search. Try different keywords.",
    aiClear: "Clear",
    aiExampleLabel: "Try:",
    aiExample1: "Remote React Developer",
    aiExample2: "Hybrid AI/ML Engineer",
    aiExample3: "Istanbul Product Manager",
    aiExample4: "Remote UI/UX Designer",
    aiInputLabel: "Job search",
    openingsTitle: "Open Positions",
    openingsCount: "open listings",
    jobViewDetail: "View Details",
    jobNotFound: "Listing Not Found",
    jobNotFoundDesc: "The job listing you're looking for doesn't exist or may have been removed.",
    detailBack: "Back to Jobs",
    detailShare: "Share",
    detailApply: "Apply Now",
    detailAbout: "About the Role",
    detailResponsibilities: "Responsibilities",
    detailRequirements: "Requirements",
    detailBenefits: "Benefits",
    detailInfo: "Position Details",
    detailLocation: "Location",
    detailWorkType: "Work Model",
    detailDepartment: "Department",
    detailExperience: "Experience",
    detailSalary: "Salary Range",
    detailPosted: "Posted:",
    detailDeadline: "Deadline:",
    detailApplyTitle: "Ready to apply for this position?",
    detailApplySubtitle: "Get a fast response through HireThink's AI-powered interview process. Submit your application via our contact page.",
    simTitle: "Check Your Fit for This Role",
    simSubtitle: "Run a position-specific interview simulation with HireThink's AI HR Assistant. Discover your strengths and development areas instantly.",
    simButton: "Start AI Simulation",
    simNote: "Simulation results are private to you. No data is shared with recruiters."
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "The Frequently Asked Questions about HireThink",
    items: [
      {
        question: "What is HireThink?",
        answer:
          "HireThink is an AI-powered recruitment and interview platform. It offers CV scoring, live AI avatar interviews, asynchronous video interviews, voice AI interviews, text AI interviews, competency and personality assessments, peer interviews, an applicant tracking system (ATS), and training modules — all in one platform. It speeds up hiring by an average of 70% and reduces CV screening time by 80%."
      },
      {
        question: "How does an AI interview work?",
        answer:
          "After creating a job posting, candidates automatically receive an interview link by email. They join via browser or phone — no app download needed. AI analyzes content, tone, fluency, and competency signals either in real time or within minutes of the interview being completed, generating a structured competency report."
      },
      {
        question: "Is HireThink KVKK and GDPR compliant?",
        answer:
          "Yes. HireThink is fully compliant with both the Turkish Personal Data Protection Law (KVKK) and the EU General Data Protection Regulation (GDPR). KVKK compliance is a core design principle — not a bolt-on. All interview recordings are stored encrypted on secure servers. Data processing and retention policies are published transparently."
      },
      {
        question: "Which industries is HireThink best suited for?",
        answer:
          "HireThink is suitable for technology, finance, retail, logistics, healthcare, call centers, manufacturing, and any organization with frequent or high-volume hiring. It is especially effective for mass recruitment, remote hiring, and fast-scaling periods. As a locally built platform, it meets Turkey-specific requirements (KVKK, Turkish Labor Law, Turkish language support) that global alternatives often lack."
      },
      {
        question: "Can HireThink integrate with my existing HR software?",
        answer:
          "Yes. HireThink supports API integration with existing HR and ERP systems such as Kolay İK, Logo HR, and SAP SuccessFactors. Applications from Kariyer.net, LinkedIn, and Indeed can be imported into the ATS. Google Calendar and Outlook Calendar integrations are also supported. For detailed integration information, contact info@hirethink.ai."
      },
      {
        question: "What is the difference between the Premium Live AI Interview and the Standard Video Interview?",
        answer:
          "The Premium Live AI Avatar Interview is a real-time, interactive session: the AI avatar speaks with the candidate live and provides instant competency analysis. The Standard Video AI Interview is asynchronous: the candidate records answers at their own pace, and AI evaluates them afterward. Live interviews provide deeper competency assessment; standard interviews scale without scheduling coordination."
      },
      {
        question: "Can HireThink handle high-volume hiring?",
        answer:
          "Yes. With bulk candidate upload via Excel, automated invitation sending, and concurrent multi-session support, HireThink is purpose-built for high-volume hiring. The CV scoring module ranks hundreds of applications in seconds, automatically creating a shortlist."
      },
      {
        question: "Which AI models does HireThink use?",
        answer:
          "HireThink runs on a multi-model AI infrastructure that selects the best-suited model for each task. Avatar voice is delivered with advanced speech synthesis technology in 30+ languages."
      },
      {
        question: "What is HireThink's pricing?",
        answer:
          "Pricing varies by company size, usage needs, and selected modules. Monthly and annual billing options are available. Request a demo for detailed pricing: info@hirethink.ai or +90 850 307 80 61."
      },
      {
        question: "Can I request a demo?",
        answer:
          "Yes. Request a demo via info@hirethink.ai or through the contact form on our website. Our team will get back to you promptly."
      },
      {
        question: "How long is the answering time?",
        answer:
          "The answer time depends on the duration you select while creating the interview. A visual warning is shown a few seconds before the timer ends, and the candidate is expected to finish within that time. Answers submitted after the time limit are not considered valid."
      },
      {
        question: "When can the candidate attend the interview?",
        answer:
          "As soon as you send the interview invitation, the candidate receives an email with an access link. The candidate can join anytime within the invitation’s validity period."
      },
      {
        question: "How long does it take for the candidate to complete the video interview I sent?",
        answer:
          "This depends entirely on your interview settings. You can define a start and end time window. Once the time window expires, the invitation becomes invalid."
      },
      {
        question: "What happens if the candidate does not complete the video interview within the specified time?",
        answer:
          "If the candidate leaves the interview unfinished and the interview is still within the active time window, they can rejoin using the same link and continue from where they left off. This will be reported to you in the Anomaly Reports. If your time window has already expired, the invitation becomes invalid."
      },
      {
        question: "If the candidate closes the interview before completing it, can they continue from where they left off?",
        answer:
          "Yes. If the interview is still active, the candidate can rejoin via the same link and continue from where they left off. You will be notified via Anomaly Detection / Anomaly Reports."
      },
      {
        question: "Are there sample questions I can ask the candidate?",
        answer:
          "Yes. You can select questions from our question bank, which includes both general and professional questions. For more role-specific questions, you can generate questions with AI when you create your interview."
      },
      {
        question: "How can I invite candidates to the interview?",
        answer:
          "You can invite candidates in 3 ways: (1) add them one by one via the “Invite Candidates” button, (2) upload in bulk using an Excel file, or (3) use job-post redirection (application redirection)."
      },
      {
        question: "Why were interviews sent to only some of the candidates I wanted to send to?",
        answer:
          "Invitations cannot be sent to candidates with missing or invalid information (e.g., an invalid email address). This will be reported to you by the system."
      },
      {
        question: "How can I check the completion status of the interviews I sent?",
        answer:
          "There are multiple ways: you can track recent candidate activity on the Dashboard, or go to the job post details page to see all candidate statuses and filter the list by status."
      },
      {
        question: "How can I manage my candidate evaluation process in HireThink?",
        answer:
          "While reviewing completed interviews, you can take notes in the HR Notes field. You can also view other HR notes within your company and compare candidates through our ATS system."
      },
      {
        question: "Can I get the interview results in an Excel file?",
        answer:
          "Yes. You can easily download the results as an Excel file by clicking the “Export Excel” button."
      },
      {
        question: "Can I search/filter candidates by name, surname, and email address?",
        answer:
          "Yes. Candidates can be searched across sent interviews by name, surname, email, and many other metrics."
      },
      {
        question: "How can I activate a passive interview?",
        answer:
          "To activate a passive interview, open “Edit Interview” and change its status to “Active.”"
      },
      {
        question: "How can I edit a video interview I created before?",
        answer:
          "Select the interview you want to update and use the “Edit” / “Edit Interview” option to make changes."
      },
      {
        question: "Can I change the questions of the interviews I created before?",
        answer:
          "If you haven’t sent the interview to candidates yet, you can add or remove questions. If it has already been sent, you can only update the interview title."
      },
      {
        question: "I changed the title of an interview I sent to candidates before. Will the emails sent to candidates be updated?",
        answer:
          "No. The title is only for your internal tracking and does not affect emails sent to candidates."
      },
      {
        question: "Can I send a different interview to the same candidate within 7 days?",
        answer:
          "Yes. You can send an unlimited number of interviews to the same candidate."
      },
      {
        question: "How can I share candidates’ results with my teammates?",
        answer:
          "There are multiple ways. The simplest is sharing the results link (even if they don’t have a HireThink account). You can also export the results as PDF and share them with your team."
      },
      {
        question: "How are my interview requests communicated to candidates?",
        answer:
          "Video interview invitations are sent to candidates via email. If a candidate does not attend, a reminder email is sent on the last day."
      },
      {
        question: "How can I delete a team member user?",
        answer:
          "You can delete a user from the “Manage Members” section by selecting the user and clicking “Delete.”"
      },
      {
        question: "How can I edit user information?",
        answer:
          "Click your username and open “Edit Profile” to update your name, surname, and password."
      },
      {
        question: "How much does HireThink cost?",
        answer:
          "It depends on the plan you choose. Pricing varies based on monthly or annual billing."
      },
      {
        question: "Can I cancel my subscription?",
       answer:
          "Yes. You can cancel your subscription from the subscription information section."
      }
    ]
  },
  cookieConsent: {
    title: "About Cookies",
    description: "This website uses cookies to improve your experience and analyze site performance. For more information about cookie usage, please see our",
    learnMore: "cookie policy",
    acceptAll: "Accept All",
    rejectAll: "Reject All",
    settings: "Settings",
    settingsTitle: "Cookie Preferences",
    settingsDescription: "You can select from the following cookie categories:",
    necessaryTitle: "Necessary Cookies",
    necessaryDesc: "Cookies required for the website to function. These cookies cannot be disabled.",
    functionalTitle: "Functional Cookies",
    functionalDesc: "Cookies that help us remember your user settings, such as language preferences.",
    analyticsTitle: "Analytics Cookies",
    analyticsDesc: "Cookies that help us understand how the website is used (Google Analytics, etc.).",
    marketingTitle: "Marketing Cookies",
    marketingDesc: "Cookies that help us show you more relevant content and advertisements.",
    cookiePolicy: "Cookie Policy",
    cancel: "Cancel",
    savePreferences: "Save Preferences"
  },
  paymentModal: {
    invoiceInfo: "Invoice Information",
    payment: "Payment",
    yearly: "Yearly",
    monthly: "Monthly",
    close: "Close",
    companyInfo: "Company Information",
    companyName: "Company Name",
    companyNamePlaceholder: "Enter your company name",
    taxNumber: "Tax Number",
    taxNumberPlaceholder: "Enter your tax number",
    taxOffice: "Tax Office",
    taxOfficePlaceholder: "Enter your tax office name",
    address: "Address",
    addressPlaceholder: "Enter your company address",
    authorizedPersonName: "Authorized Person First Name",
    authorizedPersonNamePlaceholder: "Enter your first name",
    authorizedPersonSurname: "Authorized Person Last Name",
    authorizedPersonSurnamePlaceholder: "Enter your last name",
    email: "Email",
    emailPlaceholder: "example@company.com",
    phone: "Phone Number",
    phonePlaceholder: "+1 555 123 4567",
    required: "required",
    invalidEmail: "Please enter a valid email address",
    invalidPhone: "Please enter a valid phone number",
    orderSummary: "Order Summary",
    plan: "Plan:",
    period: "Period:",
    unitPrice: "Unit Price:",
    total12Months: "Total (12 Months):",
    subtotal: "Subtotal:",
    vat: "VAT (20%):",
    total: "Total:",
    exchangeRateNote: "* Exchange rate: 1 $ = {{rate}} ₺",
    proceedToPayment: "Proceed to Payment",
    cardInfo: "Credit Card Information",
    cardNumber: "Card Number",
    cardNumberPlaceholder: "1234 5678 9012 3456",
    cardName: "Cardholder Name",
    cardNamePlaceholder: "NAME SURNAME",
    expiryDate: "Expiry Date",
    expiryDatePlaceholder: "MM/YY",
    cvv: "CVV",
    cvvPlaceholder: "123",
    paymentSummary: "Payment Summary",
    back: "Back",
    processing: "Processing...",
    pay: "Pay",
    paymentFailed: "Payment Failed",
    paymentFailedMessage: "An error occurred, no charge was made",
    requiredField: "*",
    month: "Month",
    months: "Months"
  },
  interviewObserver: {
    badge: "AI Interview Observer",
    heroTitle1: "Neutral AI Observer",
    heroTitle2: "Joins Your Live Interview",
    heroSubtitle: "HireThink Observer silently joins your Google Meet, Zoom, or Teams call and objectively evaluates both the candidate and the HR interviewer. Ensure fairness, quality, and legal compliance in every interview with AI.",
    floatBadge1Title: "Live Monitoring",
    floatBadge1Desc: "Real-time analysis",
    floatBadge2Title: "Neutral Evaluation",
    floatBadge2Desc: "Objective for both sides",
    floatBadge3Title: "Detailed Report",
    floatBadge3Desc: "Post-interview analysis",
    howTitle: "How It Works",
    howSubtitle: "Joins like a meeting bot, observes everything, and generates a comprehensive report",
    step1Title: "Invite the Bot",
    step1Desc: "Share the HireThink Observer bot link to your interview meeting. It automatically joins Zoom, Google Meet, or Teams.",
    step2Title: "Silent Observation",
    step2Desc: "The bot joins as a silent observer, analyzing audio and video streams in real time without interfering in the conversation.",
    step3Title: "Live Alerts",
    step3Desc: "When leading questions, discriminatory language, or interview quality issues are detected, HR managers receive instant notifications.",
    step4Title: "Review the Report",
    step4Desc: "As soon as the interview ends, separate comprehensive evaluation reports for both the candidate and the HR interviewer are delivered to your system.",
    featuresTitle: "Observer Bot Features",
    featuresSubtitle: "AI that holistically evaluates the interview process from both the candidate's and HR's perspective",
    feature1Title: "Real-Time Observation",
    feature1Desc: "The bot joins as a silent observer and processes conversations, tone, questions, and answers within milliseconds to produce live metrics.",
    feature2Title: "HR Bias Analysis",
    feature2Desc: "Evaluates the interviewing HR professional's questions for legal compliance, neutrality, and professionalism. Automatically flags discriminatory or leading question patterns.",
    feature3Title: "Legal Compliance Audit",
    feature3Desc: "Detects questions touching on discrimination risk areas such as age, gender, marital status, or religion. Protects your company from legal risks.",
    feature4Title: "Candidate Competency Score",
    feature4Desc: "Scores the candidate's answers based on content, fluency, confidence, and competency indicators. Generates comparable standard scores across all interviews.",
    feature5Title: "Comprehensive Interview Report",
    feature5Desc: "After each interview, an HR performance report and a candidate evaluation report are generated separately. Shareable, exportable format.",
    feature6Title: "GDPR & KVKK Compliant",
    feature6Desc: "All audio and video analysis is processed on encrypted infrastructure. Participants are informed, and data is managed in compliance with legal retention periods.",
    reportTitle: "Dual-Sided Evaluation Report",
    reportSubtitle: "After the interview ends, comprehensive separate reports for both the candidate and the HR professional are automatically generated",
    reportCandidateTitle: "Candidate Report",
    reportCandidate1: "Competency-based score and detailed analysis",
    reportCandidate2: "Verbal fluency and confidence evaluation",
    reportCandidate3: "Strengths and areas for development",
    reportCandidate4: "Comparative benchmark against other candidates",
    reportHrTitle: "HR Performance Report",
    reportHr1: "Question quality and neutrality score",
    reportHr2: "Detected risky question patterns",
    reportHr3: "Interview duration and flow analysis",
    reportHr4: "Professionalism and legal compliance evaluation",
    ctaTitle: "Make Every Interview Bulletproof",
    ctaSubtitle: "With HireThink Observer, every interview is neutral, standardized, and legally secure.",
    ctaButton: "Request a Demo",
    faqTitle: "AI Interview Observer — Frequently Asked Questions",
    faq1Q: "How does the AI interview observer join the interview?",
    faq1A: "The HireThink Observer bot automatically joins your Zoom, Google Meet, or Teams meeting via the link you share, and participates silently as an observer without interrupting the conversation.",
    faq2Q: "What data does the observer bot analyze?",
    faq2A: "The bot processes the audio and video stream in real time, evaluating the recruiter's questions for neutrality and legal compliance, and the candidate's answers for content, fluency, and competency signals.",
    faq3Q: "How are discriminatory or leading questions detected?",
    faq3A: "AI automatically flags question patterns that touch on discrimination-risk topics such as age, gender, marital status, or religion, and sends an instant notification to the HR manager.",
    faq4Q: "What reports are generated after the interview?",
    faq4A: "As soon as the interview ends, a candidate competency and benchmark report and a separate HR performance report — covering question quality and neutrality score — are automatically generated."
  },
  newsletter: {
    badge: "Weekly Newsletter",
    heroTitle1: "Where Is AI",
    heroTitle2: "Taking HR?",
    heroSubtitle: "Follow the AI transformation reshaping recruitment, talent assessment, and employee experience — every week, straight to your inbox. Stay ahead of the industry.",
    pill1: "AI News",
    pill2: "HR Trends",
    pill3: "Weekly Digest",
    formBadge: "Free · Weekly · Cancel Anytime",
    formTitle: "Stay One Step Ahead in HR & AI",
    formSubtitle: "Get the AI breakthroughs reshaping recruitment, standout HR strategies, and industry trends delivered straight to your inbox every week. Free to subscribe, cancel anytime.",
    firstName: "First Name",
    firstNamePlaceholder: "Your first name",
    lastName: "Last Name",
    lastNamePlaceholder: "Your last name",
    email: "Email",
    emailPlaceholder: "example@email.com",
    phone: "Phone",
    phonePlaceholder: "+1 555 123 4567",
    companyName: "Company Name",
    companyNamePlaceholder: "Your company name",
    title: "Job Title",
    titlePlaceholder: "e.g. HR Manager",
    department: "Department",
    departmentPlaceholder: "e.g. Human Resources",
    birthDate: "Date of Birth",
    consentText: "I agree to receive the weekly newsletter, product updates, and industry news from HireThink. I know I can unsubscribe at any time.",
    submit: "Subscribe",
    submitting: "Subscribing...",
    privacy: "Your personal data is protected under GDPR. Your information will not be shared with third parties.",
    successTitle: "You're Subscribed!",
    successDesc: "No development in AI and HR will happen without your knowledge. Every week we'll bring you the breakthroughs reshaping recruitment, talent assessment, and employee experience — straight to your inbox.",
    successUnsubscribe: "You can unsubscribe at any time by clicking the \"Unsubscribe\" link in any newsletter email.",
    counterLabel: "people are already in the loop",
    counterSub: "Join them and stay one step ahead.",
    errorRequired: "This field is required.",
    errorEmail: "Please enter a valid email address.",
    errorConsent: "You must agree to the newsletter to continue.",
    errorGeneric: "Something went wrong. Please try again."
  }
};

export default en;
